import Enums from 'utils/EnumsManager';
import { RESET_VIEW_GLOBAL } from 'store/global/actionType';
export const RESET_VIEW = RESET_VIEW_GLOBAL;

const { VIEWFILTER } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_FILTERS = VIEWFILTER + 'SET_FILTERS';
export const SET_CONDITION_LOGIC = VIEWFILTER + 'SET_CONDITION_LOGIC';
export const ADD_FILTER = VIEWFILTER + 'ADD_FILTER';
export const REMOVE_FILTER = VIEWFILTER + 'REMOVE_FILTER';
export const CHANGE_FILTER = VIEWFILTER + 'CHANGE_FILTER';
export const SET_SIDER_OPTIONS = VIEWFILTER + 'SET_SIDER_OPTIONS';
export const SET_SIDER_SELECTION = VIEWFILTER + 'SET_SIDER_SELECTION';
export const SYNC_SIDER_SELECTION = VIEWFILTER + 'SYNC_SIDER_SELECTION';
export const INSERT_SIDER_SELECTION = VIEWFILTER + 'INSERT_SIDER_SELECTION';
export const SET_ALL_FIELDS = `${VIEWFILTER}_SET_ALL_FIELDS`;
export const SET_TIME_RANGE_VALUE = `${VIEWFILTER}_SET_TIME_RANGE_VALUE`;



// WEBPACK FOOTER //
// ./src/components/page/ObjectFilter/components/FilterCriteria/flow/actionTypes.js